// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ej-b";
export var colorBlue = "_ej-8";
export var colorDot = "_ej-0";
export var colorDotLarge = "_ej-2";
export var colorDotSmall = "_ej-1";
export var colorGreen = "_ej-7";
export var colorGrey = "_ej-3";
export var colorOrange = "_ej-5";
export var colorPink = "_ej-a";
export var colorPurple = "_ej-9";
export var colorRed = "_ej-4";
export var colorYellow = "_ej-6";